import { LitElement, html, css } from 'lit-element';
import { Theme } from '@furo/framework/src/theme.js';
import { FBP } from '@furo/fbp';
import { i18n } from '@furo/framework';

/**
 * `part-abs-snr`
 * todo Describe your element
 *
 * @summary todo shortdescription
 * @customElement
 * @demo demo-part-abs-snr
 * @appliesMixin FBP
 */
class PartAbsSnr extends FBP(LitElement) {
  bindData(d) {
    this._FBPTriggerWire('--fields', d);
  }

  /**
   * Themable Styles
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return (
      Theme.getThemeForComponent('PartAbsSnr') ||
      css`
        :host {
          display: block;
        }

        :host([hidden]) {
          display: none;
        }

        h4 {
          margin-top: 40px;
          margin-bottom: 0;
          font-weight: Normal;
          font-size: 16px;
          letter-spacing: 0.15px;
        }
      `
    );
  }

  /**
   * @private
   * @returns {TemplateResult}
   * @private
   */
  render() {
    // language=HTML
    return html`
      <h4>${i18n.t('objekt-protokoll_abs_pruefung_nach')}:</h4>
      <furo-horizontal-flex>
        <furo-data-checkbox-input
          condensed
          ƒ-bind-data="--fields(*.pruefnach_snr_l)"
          @-click="--sel4"
          ƒ-uncheck="--sel5"
        ></furo-data-checkbox-input>
        <furo-data-checkbox-input
          condensed
          ƒ-bind-data="--fields(*.pruefnach_en_l)"
          @-click="--sel5"
          ƒ-uncheck="--sel4"
        ></furo-data-checkbox-input>
      </furo-horizontal-flex>

      <furo-form-layouter>
        <furo-data-checkbox-input
          condensed
          ƒ-bind-data="--fields(*.aenderung_l)"
          @-click="--sel1"
          ƒ-uncheck="--sel2,--sel3"
        ></furo-data-checkbox-input>
        <furo-data-checkbox-input
          condensed
          ƒ-bind-data="--fields(*.instandsetzung_l)"
          @-click="--sel2"
          ƒ-uncheck="--sel1,--sel3"
        ></furo-data-checkbox-input>
        <furo-data-checkbox-input
          condensed
          ƒ-bind-data="--fields(*.wiederholungspruefung_l)"
          @-click="--sel3"
          ƒ-uncheck="--sel1,--sel2"
        ></furo-data-checkbox-input>
      </furo-form-layouter>
    `;
  }
}

window.customElements.define('part-abs-snr', PartAbsSnr);
